<template>
  <div class="DataTable">
    <div
      data-v-fae5bece
      class="v-card__title headline lighten-2 v-card__title--primary"
    >Željene vrednosti parametara</div>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs4 pa-2>
          <v-select
            v-model="phase_to_select"
            :items="phase_to_items"
            item-text="name"
            item-value="id"
            :rules="[v => !!v || 'Obavezan podatak']"
            label="Faza"
            required
            persistent-hint
            return-object
          ></v-select>
        </v-flex>
        <v-flex xs3 pa-2>
          <v-select
            v-model="wt_select"
            :items="wt_items"
            item-text="name"
            item-value="id"
            label="Tip vina"
            persistent-hint
            return-object
            v-on:change="changeRoute"
          >
            <template slot="selection" slot-scope="data">
              <template v-if="data.item.id === undefined">Izaberite tank</template>
              <template v-else>{{ data.item.name }}</template>
            </template>
            <template slot="item" slot-scope="data">
              <template v-if="data.item.id === undefined">Izaberite tank</template>
              <template v-else>{{ data.item.name }}</template>
            </template>
          </v-select>
        </v-flex>
        <v-flex xs3 pa-2>
          <v-select
            v-model="label_select"
            :items="label_items"
            item-text="name"
            item-value="id"
            label="Etiketa"
            persistent-hint
            return-object
            v-on:change="changeRouteLabel"
          >
            <template slot="selection" slot-scope="data">
              <template v-if="data.item.id === undefined">Izaberite tank</template>
              <template v-else>{{ data.item.name }}</template>
            </template>
            <template slot="item" slot-scope="data">
              <template v-if="data.item.id === undefined">Izaberite tank</template>
              <template v-else>{{ data.item.name }}</template>
            </template>
          </v-select>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-select
            v-model="wine_select"
            :items="wine_items"
            item-value="id"
            label="Vina"
            persistent-hint
            return-object
          >
            <template slot="selection" slot-scope="data">
              <template v-if="data.item.id === undefined">Izaberite tank</template>
              <template v-else>{{ data.item.year }}</template>
            </template>
            <template slot="item" slot-scope="data">
              <template v-if="data.item.id === undefined">Izaberite tank</template>
              <template v-else>{{ data.item.year }}</template>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
      <!-- /.Name -->
      <v-layout row wrap>
        <v-flex xs3 pa-2>
          <v-select
            v-model="parameter_select"
            :items="parameter_items"
            item-text="name"
            item-value="id"
            :rules="[v => !!v || 'Obavezan podatak']"
            label="Parametar"
            required
            persistent-hint
            return-object
            v-on:change="changeRouteParameter"
          ></v-select>
        </v-flex>

        <v-flex xs3 pa-2>
          <v-text-field v-model="param_value" label="Željena vrednost" type="number"
          :rules="[v => !!v || 'Obavezan podatak']"
            required
            ></v-text-field>
        </v-flex>

        <v-flex xs3 pa-2>
          <v-select
            v-model="jm_select"
            :items="jm_items_dodatak"
            item-text="name"
            item-value="id"
            label="JM"
            persistent-hint
            return-object
            :rules="[v => !!v || 'Obavezan podatak']"
            required
          ></v-select>
        </v-flex>

        <v-flex xs2 pa-2>
          <v-menu
            ref="menu"
            :close-on-content-click="false"
            v-model="menu"
            :nudge-right="0"
            :return-value.sync="date"
            transition="scale-transition"
            lazy
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="date"
              label="Datum"
              readonly
              :rules="[v => !!v || 'Obavezan podatak']"
              required
            ></v-text-field>
            <v-date-picker v-model="date" no-title scrollable :max="maxDate" v-on:change="$refs.menu.save(date)">
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
              <!-- <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn> -->
            </v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <v-btn :disabled="!valid" @click="submit" class="AppButtonFilled">Sačuvaj</v-btn>
          <v-btn @click="clear" class="AppButtonOutlined">odustani</v-btn>
        </v-flex>
      </v-layout>
      <!-- /.Action buttons -->
    </v-form>
    <TokenComponent ref="frmtoken"/>
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  name: "SetParameterItem",
  components: {
      TokenComponent
    },
  data: () => ({
    valid: true,
    ID: "0",
    naziv: "",
    opis: "",
    jm_select: undefined,
    jm_select_init: undefined,
    jm_items: [],
    jm_items_dodatak: [],
    wt_items: [],
    wt_items_init: [],
    wt_select: 0,
    label_items: [],
    label_items_init: [],
    label_select: 0,
    wine_items: [],
    wine_items_init: [],
    wine_select: 0,
    wine_select_init: 0,
    wine_name: "",
    parameter_select: 0,
    parameter_items: [],
    param_value: 0,
    phase_to_items: [],
    phase_to_select: "",
    date: null, //For datepicker
    menu: ""
  }),

  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    }
  },
  methods: {
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    newSifarnik() {
      if (
        this.wt_select === undefined &&
        this.label_select === undefined &&
        this.wine_select === undefined
      )
        alert("Morate navesti jedan tip vina, etiketu ili konkretno vino.");
      else {
        var pom_wt_select;

        if (this.wt_select.id === undefined) pom_wt_select = this.wt_select;
        else pom_wt_select = this.wt_select.id;

        var complexWTObject = {
          id: pom_wt_select
        };

        var pom_label_select;

        if (this.label_select === undefined) pom_label_select = null;
        else {
          if (this.label_select.id === undefined)
            if (isNaN(this.label_select))
              pom_label_select = null;
            else
              pom_label_select = this.label_select;
          else pom_label_select = this.label_select.id;

          var complexLabelObject = {
            id: pom_label_select
          };
        }

        var pom_wine_select;

        if (this.wine_select === undefined) pom_wine_select = null;
        else {
          if (this.wine_select.id === undefined)
            if (isNaN(this.wine_select))
              pom_wine_select = null;
            else
              pom_wine_select = this.wine_select;
          else pom_wine_select = this.wine_select.id;

          var complexWineObject = {
            id: pom_wine_select
          };
        }
        var pom_jm_to_select;

        if (this.jm_select.id === undefined) pom_jm_to_select = this.jm_select;
        else pom_jm_to_select = this.jm_select.id;

        var complexJMObject = {
          id: pom_jm_to_select
        };

        var pom_parameter_select;

        if (this.parameter_select.id === undefined)
          pom_parameter_select = this.parameter_select;
        else pom_parameter_select = this.parameter_select.id;

        var complexParamObject = {
          id: pom_parameter_select
        };

        var pom_phase_to_select;

        if (this.phase_to_select.id === undefined)
          pom_phase_to_select = this.phase_to_select;
        else pom_phase_to_select = this.phase_to_select.id;

        var complexPhaseObject = {
          id: pom_phase_to_select
        };

if (pom_wine_select === null){
  if (pom_label_select === null)
        var complexObject = {
          id: this.ID,
          wineType: complexWTObject,
          phase: complexPhaseObject,
          parameter: complexParamObject,
          unitOfMeasure: complexJMObject,
          value: this.param_value,
          date: this.date
        };
    else
      var complexObject = {
          id: this.ID,
          wineLabel: complexLabelObject,
          phase: complexPhaseObject,
          parameter: complexParamObject,
          unitOfMeasure: complexJMObject,
          value: this.param_value,
          date: this.date
        };
}
else
  var complexObject = {
          id: this.ID,
          wine: complexWineObject,
          phase: complexPhaseObject,
          parameter: complexParamObject,
          unitOfMeasure: complexJMObject,
          value: this.param_value,
          date: this.date
        };

        // // console.log(JSON.stringify(complexObject));

      this.$http
        .post(this.globalServiceLocation + this.globalPort + "/desired_parameter_value/create", complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          serverBus.$emit("refresh_setparameter");

          this.clear();
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
      }
    },
    changeSifarnik() {
      if (
        this.wt_select === undefined &&
        this.label_select === undefined &&
        this.wine_select === undefined
      )
        alert("Morate navesti jedan tip vina, etiketu ili konkretno vino.");
      else {
        var pom_wt_select;

        if (this.wt_select.id === undefined) pom_wt_select = this.wt_select;
        else pom_wt_select = this.wt_select.id;

        var complexWTObject = {
          id: pom_wt_select
        };

        var pom_label_select;

        if (this.label_select === undefined) pom_label_select = null;
        else {
          if (this.label_select.id === undefined)
            if (isNaN(this.label_select))
              pom_label_select = null;
            else
              pom_label_select = this.label_select;
          else pom_label_select = this.label_select.id;

          var complexLabelObject = {
            id: pom_label_select
          };
        }

        var pom_wine_select;

        if (this.wine_select === undefined) pom_wine_select = null;
        else {
          if (this.wine_select.id === undefined)
            if (isNaN(this.wine_select))
              pom_wine_select = null;
            else
              pom_wine_select = this.wine_select;
          else pom_wine_select = this.wine_select.id;

          var complexWineObject = {
            id: pom_wine_select
          };
        }
        var pom_jm_to_select;

        if (this.jm_select.id === undefined) pom_jm_to_select = this.jm_select;
        else pom_jm_to_select = this.jm_select.id;

        var complexJMObject = {
          id: pom_jm_to_select
        };

        var pom_parameter_select;

        if (this.parameter_select.id === undefined)
          pom_parameter_select = this.parameter_select;
        else pom_parameter_select = this.parameter_select.id;

        var complexParamObject = {
          id: pom_parameter_select
        };

        var pom_phase_to_select;

        if (this.phase_to_select.id === undefined)
          pom_phase_to_select = this.phase_to_select;
        else pom_phase_to_select = this.phase_to_select.id;

        var complexPhaseObject = {
          id: pom_phase_to_select
        };

if (pom_wine_select === null){
  if (pom_label_select === null)
        var complexObject = {
          id: this.ID,
          wineType: complexWTObject,
          phase: complexPhaseObject,
          parameter: complexParamObject,
          unitOfMeasure: complexJMObject,
          value: this.param_value,
          date: this.date
        };
    else
      var complexObject = {
          id: this.ID,
          wineLabel: complexLabelObject,
          phase: complexPhaseObject,
          parameter: complexParamObject,
          unitOfMeasure: complexJMObject,
          value: this.param_value,
          date: this.date
        };
}
else
  var complexObject = {
          id: this.ID,
          wine: complexWineObject,
          phase: complexPhaseObject,
          parameter: complexParamObject,
          unitOfMeasure: complexJMObject,
          value: this.param_value,
          date: this.date
        };
        

        // // console.log(JSON.stringify(complexObject));

        this.$http
          .put(
            this.globalServiceLocation + this.globalPort + "/desired_parameter_value/update/",
            complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
          )
          .then(response => {
            serverBus.$emit("refresh_setparameter");

            this.clear();
          })
          .catch(e => {
            // // console.log(e.response);

            if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
          .put(
            this.globalServiceLocation + this.globalPort + "/desired_parameter_value/update/",
            complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
          )
          .then(response => {
            serverBus.$emit("refresh_setparameter");

            this.clear();
          })
          .catch(e => {
            // // console.log(e.response);

            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
          });
      }
    },
    getAllFaze() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/phase/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          //// // console.log(response.data);
          this.phase_to_items = response.data;
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .get(this.globalServiceLocation + this.globalPort + "/phase/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          //// // console.log(response.data);
          this.phase_to_items = response.data;
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    getAllTipoveVina() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine_type/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          //// // console.log(response.data);

          this.wt_items_init = response.data;
          this.wt_items_init.splice(0, 0, {
            id: undefined,
            name: undefined
          });

          // // console.log(this.wt_items_init);

          this.wt_items = this.wt_items_init;
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine_type/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          //// // console.log(response.data);

          this.wt_items_init = response.data;
          this.wt_items_init.splice(0, 0, {
            id: undefined,
            name: undefined
          });

          // // console.log(this.wt_items_init);

          this.wt_items = this.wt_items_init;
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    getAllEtikete(wine_type_id) {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine_label/wine_type/" + wine_type_id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          //// // console.log(response.data);

          this.label_items_init = response.data;
          this.label_items_init.splice(0, 0, {
            id: undefined,
            name: undefined
          });

          this.label_items = this.label_items_init;
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine_label/wine_type/" + wine_type_id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          //// // console.log(response.data);

          this.label_items_init = response.data;
          this.label_items_init.splice(0, 0, {
            id: undefined,
            name: undefined
          });

          this.label_items = this.label_items_init;
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    getAllWine(wine_label_id) {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine/wine_label/" + wine_label_id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          // // console.log(response.data);
          // this.wine_items = response.data;
          // this.wines = response.data.wines

          this.wine_items_init = response.data.wines;
          this.wine_items_init.splice(0, 0, {
            id: undefined,
            name: undefined
          });

          this.wine_items = this.wine_items_init;

          this.wine_select = this.wine_select_init;
          this.wine_select_init = undefined;
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine/wine_label/" + wine_label_id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          // // console.log(response.data);
          // this.wine_items = response.data;
          // this.wines = response.data.wines

          this.wine_items_init = response.data.wines;
          this.wine_items_init.splice(0, 0, {
            id: undefined,
            name: undefined
          });

          this.wine_items = this.wine_items_init;

          this.wine_select = this.wine_select_init;
          this.wine_select_init = undefined;
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    getAllParameters() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/parameter/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          // // console.log(response.data);

          this.parameter_items = response.data;
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .get(this.globalServiceLocation + this.globalPort + "/parameter/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          // // console.log(response.data);

          this.parameter_items = response.data;
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    changeRouteParameter(a) {
      if (a !== undefined) {
        // // // console.log(a.id);
        let obj = this.parameter_items;
        let pomA;

        if (isNaN(a.id)) pomA = a;
        else pomA = a.id;

        for (var i = 0; i < obj.length; i++) {
          // look for the entry with a matching `code` value
          if (obj[i].id == pomA) {
            if (obj[i].unitOfMeasure !== null)
              if (obj[i].unitOfMeasure.length !== 0)
                this.jm_items_dodatak = obj[i].unitOfMeasure;
              else this.jm_items_dodatak = this.jm_items;
            else this.jm_items_dodatak = this.jm_items;
          }
        }


        this.jm_select = this.jm_select_init;
        this.jm_select_init = undefined;
      }
    },
    changeRoute(a) {
      if (typeof a !== "undefined") {
        if (a.id === undefined) {
          if (a !== undefined) {
            this.getAllEtikete(a);
            this.wine_items = [];
            this.wine_select = undefined;

            // } else if (typeof this.tank_to_select === "undefined"){

            //   this.tank_to_select = "undefined";
          } else {
            this.label_items = [];
            this.wine_items = [];

            this.label_select = undefined;
            this.wine_select = undefined;
          }
        } else {
          this.getAllEtikete(a.id);
          this.wine_items = [];
          this.wine_select = undefined;
        }
      } else {
        this.label_items = [];
        this.wine_items = [];

        this.label_select = undefined;
        this.wine_select = undefined;
      }
    },
    // changeRouteLabel(a) {
    //   

    //   if (typeof a !== "undefined") {
    //     if (a.id === undefined) {
    //       if (a !== undefined) {
    //         this.getAllWine(a);

    //       }
    //       else {
    //       this.wine_items = [];

    //         this.wine_select = 0;
    //     }
    //     } else {
    //       this.getAllWine(a.id);
    //     }
    //   }
    //   else{
    //         this.wine_items = [];

    //         this.wine_select = 0;
    //       }
    // },
    changeRouteLabel(a) {
      
      if (a !== undefined)
        if (isNaN(a))
          if (isNaN(a.id)) {
            this.wine_items = [];

            this.wine_select = undefined;
          } else this.getAllWine(a.id);
        else this.getAllWine(a);
      else {
        this.wine_items = [];

        this.wine_select = undefined;
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.ID != "" && this.ID != "0") {
          this.changeSifarnik();
        } else {
          this.newSifarnik();
        }
      }
    },
    clear() {
      this.$refs.form.reset();
      this.ID = 0;
    },
    getAllJediniceMere() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/unit_of_measure/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          //// // console.log(response.data);

          this.jm_items = response.data;
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .get(this.globalServiceLocation + this.globalPort + "/unit_of_measure/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          //// // console.log(response.data);

          this.jm_items = response.data;
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    }
  },
  mounted() {
    this.clear();

    this.getAllJediniceMere();
    this.getAllTipoveVina();
    this.getAllParameters();
    this.getAllFaze();

    serverBus.$on("applied_setparameter", item => {
      // // console.log(item);

      this.ID = item.id;

      //this.wt_select =

      if (item.wineType === null)
        if (item.wineLabel === null) {
          if (item.wine !== null) {
            this.wt_select = item.wine.wineLabel.wineType.id;
            this.label_select = item.wine.wineLabel.id;
            this.wine_select_init = item.wine.id;
          }
        } else {
          this.wt_select = item.wineLabel.wineType.id;
          this.label_select = item.wineLabel.id;
        }
      else this.wt_select = item.wineType.id;

      this.parameter_select = item.parameter.id;
      this.param_value = item.value;
      this.jm_select_init = item.unitOfMeasure.id;
      this.phase_to_select = item.phase.id;
      this.date = item.date;
    });
  }
};
</script>

<style lang="scss" scoped>
.setParameterItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px;
}

// .v-input.v-text-field {
// 	margin: 0px;
// }

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}
</style>
